import {graphql, useStaticQuery} from 'gatsby'
import React from 'react'

import type {CookieManagerBannerQuery} from '@/graphql-types'
import FooterBannerComponent from '@helios/shared/components/footer-banner/footer-banner-wrapper-v2'
import {useLocalizedContent} from '@helios/shared/hooks/use-localized-content'

export const FooterBanner = ({withOverlay}: {withOverlay: boolean}) => {
    const {allPrismicCookieManager} = useStaticQuery<CookieManagerBannerQuery>(query)
    const [content] = useLocalizedContent(allPrismicCookieManager.nodes)

    const cookieCategories = Object.entries(content.data.cookie_categories[0]).map(
        ([key, data]) => {
            const cookies = data.document?.data.cookies.map((cookie) => ({
                id: cookie.cookie_id,
                category: key,
                name: cookie.name,
            }))

            return {
                key,
                data: {
                    bannerTitle: data.document?.data.banner_title,
                    description: data.document?.data.description,
                    linkText: data.document?.data.link_text,
                    toggleText: data.document?.data.toggle_text,
                    cookies,
                },
            }
        }
    )

    return (
        <FooterBannerComponent
            withOverlay={withOverlay}
            content={{
                ...content.data,
                title: content.data.title,
                description: content.data.description.richText,
                acceptCookiesText: content.data.accept_cookies_text,
                customiseText: content.data.customise_text,
                declineCookiesText: content.data.decline_cookies_text,
                savePreferencesText: content.data.save_preferences_text,
                cookieCategories: cookieCategories,
            }}
        />
    )
}

const query = graphql`
    query CookieManagerBanner {
        allPrismicCookieManager {
            nodes {
                lang
                data {
                    title
                    description {
                        richText
                    }
                    save_preferences_text
                    decline_cookies_text
                    decline_all_cookies_success_message
                    accept_cookies_text
                    accept_all_cookies_success_message
                    customise_text
                    cookie_categories {
                        necessary_cookies {
                            document {
                                ... on PrismicCookieCategory {
                                    ...CookieDetails
                                }
                            }
                        }
                        performance_cookies {
                            document {
                                ... on PrismicCookieCategory {
                                    ...CookieDetails
                                }
                            }
                        }
                        functional_cookies {
                            document {
                                ... on PrismicCookieCategory {
                                    ...CookieDetails
                                }
                            }
                        }
                        marketing_cookies {
                            document {
                                ... on PrismicCookieCategory {
                                    ...CookieDetails
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`
